import { DealStatusEnum, LookbackOption, type PersistedDefaultTabProps } from '@talos/kyoko';
import type { OTCTabProps } from './OTCDerivatives';

export const OPEN_OTC_DERIVATIVES_TAB_ID = 'open-otc-derivatives';
export const ACTIVE_OTC_DERIVATIVES_TAB_ID = 'active-otc-derivatives';

export const DEFAULT_OTC_TABS: PersistedDefaultTabProps<OTCTabProps>[] = [
  {
    label: 'Open',
    id: OPEN_OTC_DERIVATIVES_TAB_ID,
    closable: false,
    editable: false,
    defaultFilter: {
      Statuses: [DealStatusEnum.New, DealStatusEnum.Pending, DealStatusEnum.Live], // Exclude Canceled and Expired
    },
  },
  {
    label: 'Active',
    id: ACTIVE_OTC_DERIVATIVES_TAB_ID,
    closable: false,
    editable: false,
    defaultFilter: {
      Statuses: [DealStatusEnum.Live], // Only Live status positions
    },
  },
];

export const NEW_OTC_TAB_DEFAULTS: OTCTabProps = {
  defaultFilter: {
    _start: LookbackOption.PastWeek,
    TimestampField: 'TradeTime',
  },
};
